module.exports = __webpack_public_path__ + "img/4.f7fada2d.jpg";